/** Fixed names/content for infant profile walkthroughs (no real client data). */

export const DUMMY_INFANT_FIRST_NAME = 'Sipho';
export const DUMMY_CAREGIVER_FIRST_NAME = 'Thandi';

export const dummyInfantWalkthroughLabel = `${DUMMY_CAREGIVER_FIRST_NAME} & ${DUMMY_INFANT_FIRST_NAME}`;

export const dummyInfantProgressData = {
  progressBar: {
    message: `${DUMMY_INFANT_FIRST_NAME} needs urgent support`,
    label: '3/7',
    value: 0,
    primaryColour: 'errorMain' as const,
    secondaryColour: 'errorBg' as const,
  },
  growCard: {
    comment: `${DUMMY_INFANT_FIRST_NAME} is not growing well`,
    color: 'error',
  },
  weightCard: {
    value: '4.2',
    color: 'Error',
    comment: 'Severely underweight',
  },
  infoCard: {
    error: [
      {
        comment: `${DUMMY_INFANT_FIRST_NAME} has a fever and is not feeding`,
        visitData: { visitName: 'Pillar 4' },
      },
    ],
  },
};

export const dummyInfantReferralsData = {
  sections: [
    {
      label: 'Clinic referrals:',
      value: 'clinicReferrals',
    },
  ],
  questions: {
    clinicReferrals: [
      {
        id: 'walkthrough-ref-01',
        comment: 'Missed clinic visit',
        isCompleted: false,
        insertedDate: new Date(),
        section: 'Clinic referrals',
      },
      {
        id: 'walkthrough-ref-02',
        comment: 'Immunisations and Vitamin A not up to date',
        isCompleted: false,
        insertedDate: new Date(),
        section: 'Clinic referrals',
      },
    ],
  },
  completedReferrals: [
    {
      id: 'walkthrough-ref-done-01',
      comment: 'MUAC is less than 12.5cm',
      isCompleted: true,
      insertedDate: new Date(),
    },
  ],
};
